<template>
  <swiper
    :modules="modules"
    effect="fade"
    :slides-per-view="1"
    :loop="true"
    :speed="600"
    :autoplay="{
      delay: 4000,
      disableOnInteraction: false,
    }"
    class="work-swiper"
  >
    <swiper-slide v-for="(slide, index) in slides" :key="index">
      <div class="slide">
        <picture class="slide-picture">
          <source media="(max-width: 767px)" :srcset="slide.img375" />
          <source media="(max-width: 1023px)" :srcset="slide.img768" />
          <source media="(max-width: 1279px)" :srcset="slide.img1024" />
          <source media="(max-width: 1439px)" :srcset="slide.img1280" />
          <source media="(max-width: 1919px)" :srcset="slide.img1440" />
          <img
            class="slide-image"
            :src="slide.img1920"
            :alt="$t('homeNew.work.slides.' + index + '.line1')"
          />
        </picture>
        <div class="slide-text">
          <div class="slide-text-inner">
            <div class="slide-line1">{{ $t('homeNew.work.slides.' + index + '.line1') }}</div>
            <div class="slide-line2">{{ $t('homeNew.work.slides.' + index + '.line2') }}</div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import work1_375 from '@/assets/img/main-work/work_1_375.jpg';
import work1_768 from '@/assets/img/main-work/work_1_768.jpg';
import work1_1024 from '@/assets/img/main-work/work_1_1024.jpg';
import work1_1280 from '@/assets/img/main-work/work_1_1280.jpg';
import work1_1440 from '@/assets/img/main-work/work_1_1440.jpg';
import work1_1920 from '@/assets/img/main-work/work_1_1920.jpg';

import work2_375 from '@/assets/img/main-work/work_2_375.jpg';
import work2_768 from '@/assets/img/main-work/work_2_768.jpg';
import work2_1024 from '@/assets/img/main-work/work_2_1024.jpg';
import work2_1280 from '@/assets/img/main-work/work_2_1280.jpg';
import work2_1440 from '@/assets/img/main-work/work_2_1440.jpg';
import work2_1920 from '@/assets/img/main-work/work_2_1920.jpg';

import work3_375 from '@/assets/img/main-work/work_3_375.jpg';
import work3_768 from '@/assets/img/main-work/work_3_768.jpg';
import work3_1024 from '@/assets/img/main-work/work_3_1024.jpg';
import work3_1280 from '@/assets/img/main-work/work_3_1280.jpg';
import work3_1440 from '@/assets/img/main-work/work_3_1440.jpg';
import work3_1920 from '@/assets/img/main-work/work_3_1920.jpg';

import work4_375 from '@/assets/img/main-work/work_4_375.jpg';
import work4_768 from '@/assets/img/main-work/work_4_768.jpg';
import work4_1024 from '@/assets/img/main-work/work_4_1024.jpg';
import work4_1280 from '@/assets/img/main-work/work_4_1280.jpg';
import work4_1440 from '@/assets/img/main-work/work_4_1440.jpg';
import work4_1920 from '@/assets/img/main-work/work_4_1920.jpg';

import work5_375 from '@/assets/img/main-work/work_5_375.jpg';
import work5_768 from '@/assets/img/main-work/work_5_768.jpg';
import work5_1024 from '@/assets/img/main-work/work_5_1024.jpg';
import work5_1280 from '@/assets/img/main-work/work_5_1280.jpg';
import work5_1440 from '@/assets/img/main-work/work_5_1440.jpg';
import work5_1920 from '@/assets/img/main-work/work_5_1920.jpg';

import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/effect-fade';

export default {
  name: 'MainWorkSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, EffectFade],
    };
  },
  data() {
    return {
      slides: [
        {
          img375: work1_375,
          img768: work1_768,
          img1024: work1_1024,
          img1280: work1_1280,
          img1440: work1_1440,
          img1920: work1_1920,
        },
        {
          img375: work2_375,
          img768: work2_768,
          img1024: work2_1024,
          img1280: work2_1280,
          img1440: work2_1440,
          img1920: work2_1920,
        },
        {
          img375: work3_375,
          img768: work3_768,
          img1024: work3_1024,
          img1280: work3_1280,
          img1440: work3_1440,
          img1920: work3_1920,
        },
        {
          img375: work4_375,
          img768: work4_768,
          img1024: work4_1024,
          img1280: work4_1280,
          img1440: work4_1440,
          img1920: work4_1920,
        },
        {
          img375: work5_375,
          img768: work5_768,
          img1024: work5_1024,
          img1280: work5_1280,
          img1440: work5_1440,
          img1920: work5_1920,
        },
      ],
    };
  },
};
</script>

<style scoped>
.work-swiper {
  width: 100%;
  height: 140vw;
}

@media screen and (min-width: 580px) {
  .work-swiper {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .work-swiper {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .work-swiper {
    height: calc(100vh - 192px);
  }
}

.slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.slide-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

.slide-text-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .slide-text {
    width: 50%;
    justify-content: center;
    padding: 0 40px;
  }

  .slide-text-inner {
    max-width: 600px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-text-inner {
    gap: 20px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-text {
    padding: 0 80px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-text {
    padding: 0 120px;
  }

  .slide-text-inner {
    max-width: 720px;
  }
}

.slide-line1 {
  white-space: pre-line;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 36px;
}

.slide-line2 {
  white-space: pre-line;
  line-height: 1.2;
  font-weight: 400;
  font-size: 20px;
}

@media screen and (min-width: 1024px) {
  .slide-line1 {
    font-size: 40px;
  }

  .slide-line2 {
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-line1 {
    font-size: 48px;
  }

  .slide-line2 {
    font-size: 24px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-line1 {
    font-size: 54px;
  }

  .slide-line2 {
    font-size: 26px;
  }
}
</style>
